const getAttributeContent = (selector: string, valueName: string) => {
    const content = document.querySelector(selector)?.getAttribute('content');

    if (!content) {
        throw new Error(`Failed to get ${valueName}`);
    }

    return content;
};

export const OKTA_CLIENT_ID = getAttributeContent('meta[name="okta-client-id"]', 'OKTA_CLIENT_ID');
export const OKTA_ISSUER = getAttributeContent('meta[name="okta-issuer"]', 'OKTA_ISSUER');
